import React from "react";
import { FaLightbulb, FaLayerGroup, FaRegObjectUngroup } from "react-icons/fa";
import ceilingBanner from "../assets/banner5.jpg";

export default function CeilingDesignAndLighting() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">

        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            Ceiling Design & Lighting Solutions
          </h2>
          <p className="text-muted fs-6">
            Modern ceiling concepts combined with functional and decorative lighting systems.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={ceilingBanner}
            alt="Ceiling Design and Lighting"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ delivers professionally designed ceiling systems integrated with
            modern lighting solutions. Our designs enhance aesthetics, improve illumination,
            and create comfortable, elegant spaces for residential and commercial interiors.
          </p>

          {/* KEY SERVICES */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaLayerGroup size={22} className="me-3 text-primary" />
              <span>
                Gypsum & POP Ceilings: Elegant ceiling finishes with smooth detailing and durable construction.
              </span>
            </li>

            <li className="mb-3 d-flex align-items-start">
              <FaLightbulb size={22} className="me-3 text-primary" />
              <span>
                Integrated Lighting Systems: LED panels, spotlights, strip lighting, and ambient solutions.
              </span>
            </li>

            <li className="mb-3 d-flex align-items-start">
              <FaRegObjectUngroup size={22} className="me-3 text-primary" />
              <span>
                Custom Ceiling Designs: Tailored concepts to match interior themes and spatial requirements.
              </span>
            </li>
          </ul>

          {/* WORKFLOW / PROCESS */}
          <ol className="fs-6 mb-3">
            <li>Assess space, lighting needs, and interior style requirements.</li>
            <li>Design ceiling layouts with integrated lighting plans.</li>
            <li>Execute installation with precision, safety, and premium finishes.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            From subtle modern ceilings to bold architectural statements, our ceiling and
            lighting solutions are designed to transform spaces while maintaining energy
            efficiency and long-term reliability.
          </p>
        </div>

      </div>
    </div>
  );
}
